<script lang="ts">
  export const name = 'UploadVideo';
  export let className = '';
</script>

<svg
  class="fill-current stroke-current {className}"
  stroke-width="0"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
  ><g
    ><path fill="none" d="M0 0H24V24H0z" /><path
      d="M16 4c.552 0 1 .448 1 1v4.2l5.213-3.65c.226-.158.538-.103.697.124.058.084.09.184.09.286v12.08c0 .276-.224.5-.5.5-.103 0-.203-.032-.287-.09L17 14.8V19c0 .552-.448 1-1 1H2c-.552 0-1-.448-1-1V5c0-.552.448-1 1-1h14zM9 8l-4 4h3v4h2v-4h3L9 8z"
    /></g
  ></svg
>
